var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('audio',{staticStyle:{"display":"none"},attrs:{"id":"notifications-player"}},[_c('source',{attrs:{"src":"https://cdn.purplewave.ai/sounds/notification.mp3","type":"audio/mp3"}})])
}]

export { render, staticRenderFns }